import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@progress/kendo-react-buttons'
import { useAppSelector } from '../../stores'
import { Popover, PopoverActionsBar } from '@progress/kendo-react-tooltip'
import { Avatar, StackLayout } from '@progress/kendo-react-layout'
import { Input, TextArea } from '@progress/kendo-react-inputs'

import yamadumiAuth from '../../Auth'
import { DevelopmentOnlyArea, Separator } from '../elements'

export function LoginUserInfoCard() {
  const buttonRef = React.useRef<Button>(null)
  const [showPop, setShowPop] = React.useState(false)
  const navigate = useNavigate()
  const userInfo = useAppSelector(x => x.common.userInfo)
  const userProp = useAppSelector(x => x.common.userProp)

  function navigateLogout() {
    navigate('/logout')
    setShowPop(false)
  }

  function debugCopy(text?: string) {
    if (text != null) {
      navigator.clipboard.writeText(text)
        .catch(() => alert('コピーに失敗'))
    }
  }

  return userInfo != null
    ? (<div>
      <Button fillMode='flat' ref={buttonRef} togglable selected={showPop} onClick={() => setShowPop(!showPop)}>
        <Avatar type='image' size='small' fillMode='outline'>
          <img src={userInfo.picture} />
        </Avatar>
        <span style={{ marginLeft: 5 }}>{userInfo?.name ?? '(no name)'}</span>
      </Button>
      <Popover show={showPop} anchor={buttonRef?.current?.element} position='bottom' collision={{ vertical: 'fit', horizontal: 'fit' }} style={{ zIndex: 10000 }}>
        <StackLayout orientation='vertical' gap={10}>
          <Avatar type='image' size='large' style={{ margin: 'auto' }}>
            <img src={userInfo.picture} />
          </Avatar>
          <div>
            <div>{userInfo.company_name}</div>
            <div style={{ fontSize: '1.5em' }}>{userInfo.name}</div>
          </div>
        </StackLayout>
        <Separator />
        <StackLayout orientation='vertical' gap={10} style={{ width: 250 }}>
          <div>
            <h4 style={{ margin: 0 }}>連絡先</h4>
            <div>{userInfo.email ?? '(E-Mail 未設定)'}</div>
            <div>{userInfo.phone_number ?? '(電話番号 未設定)'}</div>
          </div>
          {userProp?.lastLogin != null && (
            <div>
              <h4 style={{ margin: 0 }}>前回ログイン日時:</h4>
              <div>{userProp?.lastLogin?.date}</div>
            </div>
          )}
          <DevelopmentOnlyArea>
            <h4 className='pcy-accent' style={{ margin: 0 }}>access-token</h4>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr auto' }}>
              <Input value={yamadumiAuth.accessToken} />
              <Button icon='clip' onClick={() => debugCopy(yamadumiAuth.accessToken)} />
            </div>
            <h4 className='pcy-accent' style={{ margin: 0 }}>refresh-token</h4>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr auto' }}>
              <Input value={yamadumiAuth.dangerousRefreshToken} />
              <Button icon='clip' onClick={() => debugCopy(yamadumiAuth.dangerousRefreshToken)} />
            </div>
            <h4 className='pcy-accent' style={{ margin: 0 }}>user-info-json</h4>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr auto' }}>
              <TextArea value={JSON.stringify(userInfo, null, '\t')} />
            </div>
            <h4 className='pcy-accent' style={{ margin: 0 }}>user-prop-json</h4>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr auto' }}>
              <TextArea value={JSON.stringify(userProp, null, '\t')} />
            </div>
          </DevelopmentOnlyArea>
        </StackLayout>
        <PopoverActionsBar>
          <Button themeColor='primary' size='large' onClick={navigateLogout}>ログアウト</Button>
        </PopoverActionsBar>
      </Popover>
    </div >)
    : <></>
}
